module.exports = __webpack_public_path__ + "img/ai_icon.en.f1af16d8.png";